/**
Author - Babajan Patan
Git - https://github.com/babajanpatan
* */

import React from "react";
import PropTypes from "prop-types";

import Toggler from "./Toogler";


const propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  togglerColorBackground: PropTypes.string.isRequired
};


const TooglerContainer = ({
  onChange,
  checked,
  disabled,
  togglerColorBackground
}) => {
  return (
    <Toggler
      checked={checked}
      disabled={disabled}
      togglerColorBackground={togglerColorBackground}
      onChange={onChange}
    />
  );
};

TooglerContainer.propTypes = propTypes;

export default TooglerContainer;
